import { Container, Title, Text, Stack } from "@mantine/core";

function AccessDenied() {
  return (
    <Container size="sm" py={80}>
      <Stack align="center" spacing="md">
        <Title order={2}>Access Denied</Title>
        <Text color="dimmed" align="center">
          You do not have permission to view this page. Please contact your
          administrator if you believe this is an error.
        </Text>
      </Stack>
    </Container>
  );
}

export default AccessDenied;
